import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { TableActionConfig } from './types'
import styled from '@emotion/styled'
import { usePermissions } from '../../utils/hooks'
import { Tooltip } from '@mui/material'

export const ActionsContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
`

export const TableActions = <T,>({
  actions,
  row,
}: {
  actions: TableActionConfig<T>[]
  row: T
}) => {
  const permissionsHook = usePermissions()

  return (
    <ActionsContainer>
      {actions.map((action) => {
        const resolvedName =
          typeof action.name === 'function' ? action.name(row) : action.name

        const resolvedIcon =
          typeof action.icon === 'function' ? action.icon(row) : action.icon

        const resolvedFormat = (action as any).format

        const hasPermission =
          !action.permission || !permissionsHook
            ? true
            : permissionsHook.checkPermission(
                action.permission.entity,
                action.permission.action
              )

        if (resolvedFormat) {
          return <Box key={resolvedName}>{resolvedFormat(row)}</Box>
        }

        if (action.isCustom) {
          return (
            <Box key={resolvedName} onClick={() => action.handler(row)}>
              {resolvedIcon}
            </Box>
          )
        } else {
          const tooltipTitle =
            !hasPermission && action.permission
              ? `User has no permission to perform action: ${action.permission.entity} -> ${action.permission.action}`
              : ''

          return (
            <Tooltip key={resolvedName} title={tooltipTitle}>
              <span>
                <IconButton
                  sx={{
                    borderRadius: 8,
                    '&:hover': {
                      color: (theme) => theme.palette.primary.main,
                    },
                  }}
                  disabled={!hasPermission && !!action.permission}
                  key={resolvedName}
                  onClick={(event) => {
                    event.stopPropagation()
                    action.handler(row)
                  }}
                  title={resolvedName}
                >
                  {resolvedIcon}
                </IconButton>
              </span>
            </Tooltip>
          )
        }
      })}
    </ActionsContainer>
  )
}
